import { Typography, Card, Icon, Button } from "@plum-xoxo/admin-dsm";
import React from "react";
import styled from "styled-components";
import { app_path } from "config";
import { Link } from "react-router-dom/cjs/react-router-dom";

const ShadowedDiv = styled.div`
  box-shadow: 0px 0px 4px 0px #362a6629;
  border-radius: 8px;
`;

const data = {
  1: {
    head: "Reward Points",
    content:
      "Reward points allow your recipients to earn points over time and redeem them for existing rewards from our marketplace.",
  },
  2: {
    head: "Reward Codes",
    content:
      "Reward codes enable you to send unique codes globally for different occasions, letting recipients redeem existing rewards from our marketplace without needing to create an account.",
  },
  3: {
    head: "Reward Link",
    content:
      "Reward links let you set up campaigns easily for different events, so your recipients can quickly redeem rewards from a curated list without making an account.",
  },
  4: {
    head: "Gift Cards",
    content:
      "Easily send brand gift cards to recipients, including top global brands like Amazon and Walmart, perfect for fast distribution without login and hassle-free redemption.",
  },
};
const GetStartedDiy = ({ kybStatus, rewardType, history, setActiveTab }) => {
  return (
    <div className="mt-16 d-flex gap-20 flex-column">
      <ShadowedDiv className="p-20 d-flex flex-column gap-16">
        <Typography.ButtonText>
          🎉 Congratulations! Your account has been created.
        </Typography.ButtonText>
        <Typography.BodySmall>
          You can now explore the platform and navigate through its features.
          Complete the final steps of your account setup by finishing the
          actions below to send your first reward.
        </Typography.BodySmall>
      </ShadowedDiv>
      <Card>
        <div className="p-20">
          <Typography.ButtonText>
            {kybStatus === 0 ? (
              "Enter Business Details"
            ) : (
              <div className="d-flex align-items-center gap-8">
                <Icon
                  color="success"
                  iconName="PlumCheckbox"
                  size={24}
                  shade="c04"
                />
                Business verification is in process
              </div>
            )}
          </Typography.ButtonText>
        </div>
        {kybStatus === 0 ? <hr className="m-0" /> : ""}
        <div
          className={`d-flex gap-8 flex-column ${
            kybStatus === 0 ? "p-20" : "px-20 pb-8"
          }`}
        >
          {kybStatus === 1 ? (
            <Typography>
              Your business details are being verified and it usually takes one
              business hour.
              <Typography
                component="div"
                color="primary"
                shade="c02"
                className="cursor-pointer"
                onClick={() =>
                  history.push(
                    `/${app_path}/accounts/platform-preferences#account`
                  )
                }
              >
                View details.
              </Typography>
            </Typography>
          ) : (
            <Typography className="mb-0">
              Verify your business details to activate your account for sending
              rewards. Our team usually takes one business hour to verify after
              you submit.{" "}
            </Typography>
          )}
          {kybStatus === 0 ? (
            <Button
              className="align-self-end"
              onClick={() => {
                history.push(
                  `/${app_path}/accounts/platform-preferences#submit-kyb`
                );
              }}
            >
              Proceed
            </Button>
          ) : null}
        </div>
      </Card>
      <Card>
        <div className="p-20">
          <Typography.ButtonText>
            Explore Sending {data[rewardType]["head"]}
          </Typography.ButtonText>
        </div>
        <hr className="m-0" />
        <div className="d-flex gap-8 flex-column p-20">
          <Typography className="mb-0">
            {data[rewardType]["content"]}
          </Typography>
          <Button
            className="align-self-end"
            variant="outlined"
            onClick={() => {
              rewardType === 3 ? setActiveTab(-1) : setActiveTab(0);
            }}
          >
            Explore
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default GetStartedDiy;
